import { render, staticRenderFns } from "./MutasiKasBank.vue?vue&type=template&id=054da27b&"
import script from "./MutasiKasBank.vue?vue&type=script&lang=js&"
export * from "./MutasiKasBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MutasiKasBank.vue"
export default component.exports